import React from 'react'
import { fromJS, Map } from 'immutable'
import { withStateHandlers } from 'recompose'
import InputRange from 'react-input-range'
import 'react-input-range/lib/css/index.css'
import { limitsFromOffers, priceRangePredicate,
    ROUND_PRICE_LIMIT_TO } from './priceRange'

/** UI for an adaptive filter that filters offers based on price range,
 * by rendering a min/max slider.
 * 
 * @author Dawid Loubser
 */
const PriceRangeFilter = ({ priceFilter = Map(), setPriceFilterValue, applyPriceFilterValue }) =>
    shouldShow( priceFilter )
        ? <div className="filter priceRange">
            <h4>Price range</h4>
            <div className="uiControl">
                <InputRange 
                    minValue={priceFilter.get('minLimit')}
                    maxValue={priceFilter.get('maxLimit')}
                    value={priceFilter.get('value').toJS()}
                    onChangeComplete={applyPriceFilterValue}
                    onChange={setPriceFilterValue}/>
            </div>
        </div>
        : null


/** Determines whether the filter is rendered at all,
 * based on the price range. We here use the rounded price
 * range limits, since we don't store the actual min/max. */
const shouldShow = priceFilter =>
    (priceFilter.get('maxLimit') - priceFilter.get('minLimit')) > 2 * ROUND_PRICE_LIMIT_TO


    
export default withStateHandlers(
    // Initial state
    ({offers}) => ({
        priceFilter : limitsFromOffers(offers)
            .withMutations( m => 
                // Set selected min/max to actual limits
                m.setIn(['value','min'], m.get('minLimit'))
                    .setIn(['value','max'], m.get('maxLimit'))
            )
    }),

    // Handlers
    {
        // Quick, local price filter update (still dragging)
        setPriceFilterValue : ({priceFilter = Map()}) => 
            value => {
                // Update state
                return {
                    priceFilter : priceFilter.set('value', fromJS(value))  
                }
            },

        // Done dragging - update local filter, as well as globally apply
        applyPriceFilterValue : ({priceFilter = Map()}, { onFilter }) => 
            value => {
                const newVal = fromJS(value)

                // Send predicate filter to parent
                onFilter( priceRangePredicate(newVal) )

                // Update state
                return {
                    priceFilter : priceFilter.set('value', newVal)  
                }
            }
    }

)(PriceRangeFilter)



// WEBPACK FOOTER //
// ./src/ndc/offer/filters/priceRange/PriceRangeFilter.js